import React from 'react'


const Stats : React.FC = () => (
  <>
  </>
)

export default Stats
